<template>
    <div>
        <div class="row">
            <div class="col-lg-6 offset-lg-3 col-12 p-0">
                <div class="card shadow-sm">
                    <div class="card-header">
                        <p class="text-center" style="margin: 0px;">จำนวนเงินที่ขอสินเชื่อ</p>
                    </div>
                    <div class="card-body">
                        <p>วงเงินสินเชื่อที่ต้องการ</p>
                        <ul class="ml-3">
                            <li class="list-style">10,000 บาท</li>
                            <li class="list-style">7,500 บาท</li>
                            <li class="list-style">5,000 บาท</li>
                        </ul>
                    </div>
                </div>
                <div class="card shadow-sm">
                    <div class="card-body mt-1">
                        <p class="text-center">แผนการผ่อนชำระ</p>
                        <div class="d-flex justify-content-between box-payday">
                            <div class="bg-light px-3 day"><p class="text-center"> 90 วัน</p></div>
                            <div class=""><p class="text-rigth px-3">40 บาท/วัน</p></div>
                        </div>
                        <div class="d-flex justify-content-between box-payday">
                            <div class="bg-light px-3 day"><p class="text-center"> 180 วัน</p></div>
                            <div class=""><p class="text-rigth px-3">35 บาท/วัน</p></div>
                        </div> 
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
export default {
  methods: {
    nextPage () {
      this.$emit('next')
    }
  }
}
</script>
<style scoped>
.list-style {
    list-style-type: circle;
}
.box-payday {
    border: 1px rgb(209, 209, 209) solid;
    border-radius: 5px;
    margin: 1rem 0 1rem 0;
}
.day {
    border-radius: 5px; 
}
p {
    margin: 3px 0 3px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/nimcap/Components/Guarantor/Step7.vue